module.exports = __webpack_public_path__ + "img/about-badminton-desktop.015c126b.png";